import { Router } from '@angular/router';
import { Input } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  selector: 'siu-img-option-link',
  templateUrl: './img-option-link.component.html',
  styleUrls: [ './img-option-link.component.scss' ]
})
export class ImgOptionLinkComponent {

  @Input() imgSrc: string;
  @Input() externalLink: boolean = false;
  @Input() link: string;
  @Input() label: string;


  constructor(private router: Router) { }


  goTo = () => {
    if (this.externalLink) window.open(this.link, "_blank")
    else this.router.navigate([ this.link ]);
  }

}
